"use client";

import { useViewerLanguage } from "@/lib/i18n";
import { cn } from "@/lib/utils";
import { useLegendItem } from "./legend-context";

export interface LegendStatusProps {
  className?: string;
  labels?: Record<string, string>;
  colors?: Record<string, string>;
}

const DEFAULT_COLORS: Record<string, string> = {
  done: "var(--chart-1)",
  active: "var(--chart-1)",
  pending: "var(--subtle)",
};

export function LegendStatus({
  className = "text-xs",
  labels,
  colors,
}: LegendStatusProps) {
  const { item } = useLegendItem();
  const { t } = useViewerLanguage();
  const status = item.status;
  if (!status) return null;
  const defaultLabels: Record<string, string> = {
    done: t("done"),
    active: t("active"),
    pending: t("pending"),
  };
  const text = labels?.[status] ?? defaultLabels[status] ?? status;
  const color = colors?.[status] ?? DEFAULT_COLORS[status] ?? "var(--subtle)";
  return (
    <div className={cn(className)} style={{ color }}>
      {text}
    </div>
  );
}

LegendStatus.displayName = "LegendStatus";
